/** Greek translations for the Botilia search widget. */
export const el = {
  // SearchWidget
  'search.placeholder': 'Αναζήτηση κρασιών, ποικιλιών, παραγωγών...',
  'search.placeholder.short': 'Τι ψάχνεις σήμερα;',
  'search.close': 'Κλείσιμο αναζήτησης',
  'search.clear': 'Καθαρισμός',
  'search.searching': 'Αναζήτηση για "{query}"...',
  'search.results': '{count} αποτελέσματα',
  'search.products': '{count} προϊόντα',
  'search.resultsTime': '{count} αποτελέσματα σε {time}ms',
  'search.loadMore': 'Φόρτωσε περισσότερα',
  'search.loadMoreCount': '{count} ακόμα',
  'search.loading': 'Φόρτωση...',
  'search.error': 'Σφάλμα κατά την αναζήτηση',
  'search.aria': 'Αναζήτηση Botilia.gr',
  'search.clickToSearch': 'Κάντε κλικ για αναζήτηση',
  'search.showingResultsFor': 'Αποτελέσματα για',
  'search.searchInsteadFor': 'Αναζήτηση για',
  'search.didYouMean': 'Μήπως εννοείτε',
  'search.didYouMeanMark': ';',
  'search.category': 'Κατηγορία:',
  'search.listening': 'Ακούω...',
  'search.startListening': 'Φωνητική αναζήτηση',
  'search.stopListening': 'Διακοπή ακρόασης',
  'search.voiceNotSupported': 'Η φωνητική αναζήτηση δεν υποστηρίζεται σε αυτόν τον browser',

  // Filters
  'filter.label': 'Φίλτρα',
  'filter.category': 'Κατηγορία',
  'filter.type': 'Τύπος',
  'filter.wineType': 'Τύπος κρασιού',
  'filter.country': 'Χώρα',
  'filter.region': 'Περιοχή',
  'filter.grape': 'Ποικιλία',
  'filter.producer': 'Παραγωγός',
  'filter.winery': 'Οινοποιείο',
  'filter.subcategory': 'Υποκατηγορία',
  'filter.vintage': 'Χρονολογία',
  'filter.tags': 'Ετικέτες',
  'filter.body': 'Σώμα',
  'filter.acidity': 'Οξύτητα',
  'filter.tannins': 'Τανίνες',
  'filter.fruitiness': 'Αρωματική ένταση',
  'filter.price': 'Τιμή',
  'filter.priceFrom': 'Από',
  'filter.priceTo': 'Έως',
  'filter.inStock': 'Σε απόθεμα',
  'filter.inStockOnly': 'Μόνο διαθέσιμα',
  'filter.clearAll': 'Εκκαθάριση',
  'filter.applyFilters': 'Εφαρμογή φίλτρων',
  'filter.allCategories': 'Όλες οι κατηγορίες',
  'filter.showMore': '+{count} ακόμα',
  'filter.showLess': 'Λιγότερα',
  'filter.resultsCount': '{count} αποτελέσματα',
  'filter.showFilters': 'Εμφάνιση φίλτρων',
  'filter.hideFilters': 'Απόκρυψη φίλτρων',

  // Sort
  'sort.label': 'Ταξινόμηση',
  'sort.relevance': 'Συνάφεια',
  'sort.priceAsc': 'Τιμή: Χαμηλή → Υψηλή',
  'sort.priceDesc': 'Τιμή: Υψηλή → Χαμηλή',
  'sort.rating': 'Βαθμολογία',
  'sort.newest': 'Νεότερα',

  // ProductCard
  'product.bestSeller': 'Best Seller',
  'product.promo': 'Προσφορά',
  'product.outOfStock': 'Εξαντλημένο',
  'product.inStock': 'Διαθέσιμο',
  'product.notAvailable': 'Μη διαθέσιμο',
  'product.savings': 'Κερδίζεις {amount}',
  'product.stars': '{rating} από 5 αστέρια',

  // NoResults
  'noResults.title': 'Δεν βρέθηκαν αποτελέσματα',
  'noResults.notFound': 'Δεν βρήκαμε «{query}» στο Botilia.',
  'noResults.tryBestSellers': 'Δείτε τα best sellers παρακάτω ή δοκιμάστε κάτι πιο γενικό.',
  'noResults.message': 'Δεν βρήκαμε αποτελέσματα για «{query}»',
  'noResults.didYouMean': 'Μήπως εννοούσατε:',
  'noResults.popular': 'Δημοφιλείς αναζητήσεις',
  'noResults.tips': 'Δοκιμάστε διαφορετικές λέξεις-κλειδιά, ελέγξτε τη ορθογραφία, ή χρησιμοποιήστε πιο γενικούς όρους.',
  'noResults.tryDifferent': 'Δοκιμάστε διαφορετικές λέξεις-κλειδιά ή περιηγηθείτε στις κατηγορίες',

  // DefaultResults
  'defaults.recentlyViewed': 'Πρόσφατα προβεβλημένα',
  'defaults.recentSearches': 'Πρόσφατες αναζητήσεις',
  'defaults.clearRecent': 'Εκκαθάριση',
  'defaults.popularSearches': 'Δημοφιλείς αναζητήσεις',
  'defaults.bestSellers': 'Best Sellers',
  'defaults.promos': 'Προσφορές',
  'defaults.trending': 'Trending Τώρα',

  // Sections
  'section.products': 'Προϊόντα',
  'section.productCount': '{shown} από {total}',
  'section.articles': 'Άρθρα',
  'section.pages': 'Σελίδες',
  'section.categories': 'Κατηγορίες',
  'section.collections': 'Συλλογές',
  'section.brands': 'Brands / Παραγωγοί',
  'section.browse': 'Περιήγηση',
  'section.trending': 'Trending Τώρα',
  'section.popularSearches': 'Δημοφιλείς Αναζητήσεις',
  'section.recentSearches': 'Πρόσφατες Αναζητήσεις',

  // Actions
  'action.clear': 'Εκκαθάριση',

  // Wine types
  'wineType.red': 'Κόκκινο',
  'wineType.white': 'Λευκό',
  'wineType.rose': 'Ροζέ',
  'wineType.sparkling': 'Αφρώδες',
  'wineType.dessert': 'Γλυκό',
  'wineType.fortified': 'Ενισχυμένο',
  'wineType.orange': 'Πορτοκαλί',
} as const;

export type TranslationKey = keyof typeof el;
